module.exports = __webpack_public_path__ + "static/media/logo.9ee73c04.png";